import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PutStatusInfo, Status } from '../../services/apiTypes';
import { putStatusInfo } from './api';

interface StatusState {
  status: Status;
}

const initialState: StatusState = {
  status: 'idle',
};

export const putStatus = createAsyncThunk(
  'status/putStatusInfo',
  async (params: PutStatusInfo, { rejectWithValue }) => {
    try {
      return await putStatusInfo(params);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const statusSlice = createSlice({
  name: 'status',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(putStatus.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(putStatus.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(putStatus.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export default statusSlice.reducer;
